import {
  RiBarChartBoxLine,
  RiBuilding2Line,
  RiHotelLine,
  RiSwapBoxLine,
} from "react-icons/ri";
import { EmpreendimentoRevendaComponent } from "./components/empreendimento/empreendimento.component";
import { UnidadesRevendaComponent } from "./components/unidades/unidades.component";
import { RelatoriosRevendaComponent } from "./components/relatorios/relatorios.component";
import { TransferenciaRevendaComponent } from "./components/transferencia/transferencia.component";

export enum RevendaMenusE {
  empreendimento = 1,
  unidades = 2,
  relatorios = 3,
  transferencia = 4,
}

export const RevendaMenusC = [
  {
    id: 1,
    icon: <RiBuilding2Line size={18} />,
    content: "Empreendimento",
    isSelected: RevendaMenusE.empreendimento,
  },
  {
    id: 2,
    icon: <RiHotelLine size={18} />,
    content: "Unidades Revenda",
    isSelected: RevendaMenusE.unidades,
  },
  {
    id: 3,
    icon: <RiBarChartBoxLine size={18} />,
    content: "Relatórios",
    isSelected: RevendaMenusE.relatorios,
  },
  {
    id: 4,
    icon: <RiSwapBoxLine size={18} />,
    content: "Transferência",
    isSelected: RevendaMenusE.transferencia,
  },
];

export type RevendaComponentProps = {
  authToken: string;
};

export const RevendaMenuComponents: Record<
  RevendaMenusE,
  React.FC<RevendaComponentProps>
> = {
  [RevendaMenusE.empreendimento]: EmpreendimentoRevendaComponent,
  [RevendaMenusE.unidades]: UnidadesRevendaComponent,
  [RevendaMenusE.relatorios]: RelatoriosRevendaComponent,
  [RevendaMenusE.transferencia]: TransferenciaRevendaComponent,
};
